module.exports = __webpack_public_path__ + "img/Walls_text02_space.173e040e.png";